import { nanoid } from "nanoid";
import { BuilderList } from "./form-builder/FormBuilderTypes";

export const buildList: BuilderList[] = [
  {
    id: nanoid(),
    title: "Text",
    type: "text",
    badge: "",
    body: "Single line text inputs or multiple lines",
    subtitle: [],
    sort: 1,
    required: true,
  },
  {
    id: nanoid(),
    title: "Email",
    type: "email",
    badge: "",
    body: "Valid email text",
    subtitle: [],
    sort: 2,
    required: true,
  },
  {
    id: nanoid(),
    title: "Card",
    type: "card",
    badge: "",
    body: "Add Debit Card",
    subtitle: [],
    sort: 3,
    required: true,
  },
  {
    id: nanoid(),
    title: "Phone",
    type: "tel",
    badge: "",
    body: "Phone Number",
    subtitle: [],
    sort: 4,
    required: true,
  },
  {
    id: nanoid(),
    title: "Numeric",
    type: "number",
    badge: "",
    body: "Numeric inputs",
    subtitle: [],
    sort: 5,
    required: true,
  },
  {
    id: nanoid(),
    title: "Amount",
    type: "number",
    badge: "",
    body: "Amount",
    subtitle: [],
    sort: 6,
    required: true,
  },
  {
    id: nanoid(),
    title: "Selfie",
    type: "file",
    badge: "",
    body: "Upload an selfie or passport potograph",
    subtitle: [],
    sort: 7,
    required: true,
  },
  {
    id: nanoid(),
    title: "Work Id",
    type: "file",
    badge: "",
    body: "Upload a valid work id",
    subtitle: [],
    sort: 8,
    required: true,
  },
  {
    id: nanoid(),
    title: "Government Id",
    type: "file",
    badge: "",
    body: "Upload a valid government id",
    subtitle: ["Document Name", "Document Number"],
    sort: 9,
    required: true,
  },
  {
    id: nanoid(),
    title: "File",
    badge: "",
    type: "file",
    body: "Select a document",
    subtitle: [],
    sort: 10,
    required: true,
  },
  {
    id: nanoid(),
    title: "Bank Info",
    badge: "",
    body: "Select bank and provide bank details",
    subtitle: ["Account Number", "Account Name"],
    sort: 11,
    type: "select",
    required: true,
  },
  {
    id: nanoid(),
    title: "Select State",
    badge: "",
    body: "Select state",
    subtitle: [],
    sort: 12,
    type: "select",
    required: true,
  },
  {
    id: nanoid(),
    title: "Date",
    type: "date",
    badge: "",
    body: "Select date from calender",
    subtitle: [],
    sort: 13,
    required: true,
  },
  {
    id: nanoid(),
    title: "Image",
    type: "file",
    badge: "",
    body: "Upload an image",
    subtitle: [],
    sort: 14,
    required: true,
  },
  {
    id: nanoid(),
    title: "Url",
    type: "text",
    badge: "",
    body: "Enter webiste url",
    subtitle: [],
    sort: 15,
    required: true,
  },
  {
    id: nanoid(),
    title: "Dropdown",
    type: "dropdown",
    badge: "",
    body: "Dropdown with multiple options",
    subtitle: [],
    sort: 16,
    required: true,
    options: [
      { id: nanoid(), option: "option1", linked: false, linkedForm: "" },
    ],
  },
  {
    id: nanoid(),
    title: "Radio",
    type: "radio",
    badge: "",
    body: "Radio with mutlple options",
    subtitle: [],
    sort: 17,
    required: true,
    options: [
      { id: nanoid(), option: "option1", linked: false, linkedForm: "" },
    ],
  },
  {
    id: nanoid(),
    title: "Multiple Checkbox",
    type: "checkbox",
    badge: "",
    body: "Checkbox with mutlple options",
    subtitle: [],
    options: [
      { id: nanoid(), option: "option1", linked: false, linkedForm: "" },
    ],
    sort: 18,
    required: true,
  },
  {
    id: nanoid(),
    title: "Select LGA",
    badge: "",
    body: "Select lga",
    subtitle: [],
    sort: 20,
    type: "select",
    required: true,
  },
  {
    id: nanoid(),
    title: "Select Senatorial District",
    badge: "",
    body: "Select senatorial district",
    subtitle: [],
    sort: 21,
    type: "select",
    required: true,
  },
  {
    id: nanoid(),
    title: "List Inputs",
    badge: "",
    body: "List inputs",
    subtitle: [],
    sort: 22,
    type: "listInputs",
    required: true,
    instruction: "",
    field1: "",
    field2: "",
    inputList: [
      {
        id: nanoid(),
        valueA: "",
        valueB: "",
      },
    ],
  },
];

export const defaultTabs = [
  {
    id: "jYSVAZpYTOwDu5_-D8Yos",
    name: "Info",
    error: "",
    builders: [
      {
        id: nanoid(),
        title: "Amount",
        type: "number",
        badge: "",
        body: "Amount",
        subtitle: [],
        sort: 6,
        required: true,
        instruction: "Amount",
      },
      // {
      //   id: nanoid(),
      //   title: "Government Id",
      //   type: "file",
      //   badge: "",
      //   body: "Upload a valid government id",
      //   subtitle: ["Document Name", "Document Number"],
      //   sort: 9,
      //   required: true,
      //   instruction: "Government Id",
      // },

      {
        id: nanoid(),
        title: "Multiple Checkbox",
        type: "checkbox",
        badge: "",
        body: "Checkbox with mutlple options",
        subtitle: [],
        options: [
          { id: nanoid(), option: "option1", linked: false, linkedForm: "" },
          { id: nanoid(), option: "option2", linked: false, linkedForm: "" },
        ],
        sort: 18,
        required: true,
        instruction: "Multiple Checkbox",
      },
      {
        id: nanoid(),
        title: "Email",
        type: "email",
        badge: "",
        body: "Valid email text",
        subtitle: [],
        sort: 2,
        required: true,
        instruction: "Email",
      },
      {
        id: nanoid(),
        title: "Numeric",
        type: "number",
        badge: "",
        body: "Numeric inputs",
        subtitle: [],
        sort: 5,
        required: true,
        instruction: "Number Of People",
      },
      {
        id: nanoid(),
        title: "Phone",
        type: "tel",
        badge: "",
        body: "Phone Number",
        subtitle: [],
        sort: 4,
        required: true,
        instruction: "Phone Number",
      },
      // {
      //   id: nanoid(),
      //   title: "Work Id",
      //   type: "file",
      //   subtitle: [],
      //   instruction: "Work ID",
      //   required: true,
      // },
      // {
      //   id: nanoid(),
      //   title: "Selfie",
      //   type: "file",
      //   subtitle: [],
      //   required: true,
      //   instruction: "Selfie",
      // },

      {
        id: nanoid(),
        title: "Select State",
        badge: "",
        body: "Select state",
        subtitle: [],
        sort: 12,
        type: "select",
        required: true,
        instruction: "State ID",
      },
      {
        id: nanoid(),
        title: "File",
        type: "file",
        badge: "",
        body: "Upload a file",
        subtitle: [],
        sort: 15,
        required: true,
        instruction: "Employment Letter",
      },
      {
        id: nanoid(),
        title: "Select LGA",
        badge: "",
        body: "Select lga",
        subtitle: [],
        sort: 20,
        type: "select",
        required: true,
        instruction: "LGA",
      },
      {
        id: nanoid(),
        title: "Select Senatorial District",
        badge: "",
        body: "Select senatorial district",
        subtitle: [],
        sort: 21,
        type: "select",
        required: true,
        instruction: "Senatorial District",
      },
      {
        id: nanoid(),
        title: "Date",
        type: "date",
        subtitle: [],
        instruction: "Start Date",
        required: true,
      },
      {
        id: nanoid(),
        title: "Do you have a business?",
        type: "radio",
        badge: "",
        body: "Select with mutlple options",
        subtitle: [],
        options: [
          {
            id: nanoid(),
            option: "Yes",
            linked: true,
            linkedForm: {
              id: "m2q8MnYsfku_JEyYATqhu",
              name: "Employment Information",
              builders: [
                {
                  id: "ykydNS2kFHKERLilf9LIc",
                  title: "Text",
                  type: "text",
                  subtitle: [],
                  instruction: "Job Title",
                  required: true,
                },
                {
                  id: "kspl8usXDdTJcpCru4-dd",
                  title: "Text",
                  type: "text",
                  subtitle: [],
                  instruction: "Office Address",
                  required: true,
                },
                {
                  id: "b-1EkB6JHj_yCTmVtFFLT",
                  title: "Date",
                  type: "date",
                  subtitle: [],
                  instruction: "Start Date",
                  required: true,
                },
                // {
                //   id: "4xwFjpFcw-yW0yRUrV9lM",
                //   title: "Select State",
                //   subtitle: ["Select Lga"],
                //   type: "select",
                //   instruction: "Office State",
                //   option: "nigeriaStates",
                //   required: true,
                // },
                // {
                //   id: "pP1QoESsszQLALAy1NsuV",
                //   title: "Work Id",
                //   type: "file",
                //   subtitle: [],
                //   instruction: "Upload your work id",
                //   required: true,
                // },
              ],
              linkedToOption: true,
            },
          },
          { id: nanoid(), option: "No", linked: false, linkedForm: "" },
        ],
        required: true,
        instruction: "Do you have a business?",
      },
      {
        id: nanoid(),
        title: "Text",
        type: "text",
        subtitle: [],
        instruction: "Job Title",
        required: true,
      },
      {
        id: nanoid(),
        title: "Text",
        type: "text",
        subtitle: [],
        instruction: "Office Address",
        required: true,
      },
      {
        id: nanoid(),
        title: "List Inputs",
        badge: "",
        body: "List inputs",
        subtitle: [],
        sort: 22,
        type: "listInputs",
        required: true,
        instruction: "Employees",
        field1: "Name",
        field2: "Title",
        inputList: [
          {
            id: nanoid(),
            valueA: "",
            valueB: "",
          },
        ],
      },
    ],
  },
  {
    id: nanoid(),
    name: "Employment Information",
    linkedToOption: true,
    builders: [
      {
        id: nanoid(),
        title: "Text",
        type: "text",
        subtitle: [],
        instruction: "Job Title",
        required: true,
      },
      {
        id: nanoid(),
        title: "Text",
        type: "text",
        subtitle: [],
        instruction: "Office Address",
        required: true,
      },
      {
        id: nanoid(),
        title: "Date",
        type: "date",
        subtitle: [],
        instruction: "Start Date",
        required: true,
      },
      // {
      //   id: nanoid(),
      //   title: "Select State",
      //   subtitle: ["Select Lga"],
      //   type: "select",
      //   instruction: "Office State",
      //   option: "nigeriaStates",
      //   required: true,
      // },
      {
        id: nanoid(),
        title: "Work Id",
        type: "file",
        subtitle: [],
        instruction: "Upload your work id",
        required: true,
      },
    ],
  },
  {
    id: nanoid(),
    name: "Guarantors's Information",
    builders: [
      {
        id: nanoid(),
        title: "Text",
        type: "text",
        subtitle: [],
        instruction: "FullName",
        required: true,
      },
      {
        id: nanoid(),
        title: "Email",
        type: "email",
        subtitle: [],
        instruction: "Email Address",
        required: true,
      },
      {
        id: nanoid(),
        title: "Phone",
        type: "tel",
        subtitle: [],
        instruction: "Phone Number",
        required: true,
      },
      {
        id: nanoid(),
        title: "Text",
        type: "text",
        subtitle: [],
        instruction: "Address",
        required: true,
      },
      {
        id: nanoid(),
        title: "Select",
        subtitle: [],
        type: "select",
        instruction: "Residential State",
        option: "nigeriaStates",
        required: true,
      },
      {
        id: nanoid(),
        title: "Select",
        subtitle: [],
        type: "select",
        instruction: "Residential LGA",
        option: "lgas",
        required: true,
      },
    ],
  },
  {
    id: nanoid(),
    name: "Bank Information",
    builders: [
      {
        id: nanoid(),
        title: "Bank Info",
        subtitle: ["Account Number", "Account Name"],
        type: "select",
        instruction: "Choose Bank",
        option: "banks",
        required: true,
      },
    ],
  },
  {
    id: nanoid(),
    name: "Card Information",
    builders: [
      {
        id: nanoid(),
        title: "Card",
        type: "text",
        subtitle: [],
        instruction: "Add Card",
        required: true,
      },
    ],
  },
  {
    id: nanoid(),
    name: "Supporting Documents",
    builders: [
      {
        id: nanoid(),
        title: "File",
        type: "file",
        subtitle: [],
        instruction: "Supporting Documents",
        required: true,
      },
    ],
  },
];

export const previewTab = [
  {
    id: "0hx_6t9PyDGL5BN6Yv0WQ",
    name: "test 1",
    builders: [
      {
        id: nanoid(),
        title: "Multiple Checkbox",
        type: "checkbox",
        badge: "",
        body: "Checkbox with mutlple options",
        subtitle: [],
        sort: 18,
        required: true,
        options: [
          {
            id: "WWLKxKyJVElovqulZeLpM",
            option: "option1",
            linked: false,
            linkedForm: "",
          },
          {
            id: "3nn_klCa5VHk7SIBLxVq-",
            option: "option 2",
            linked: true,
            linkedForm: {
              id: "zHwcgh9vTr4-QW8ODyNx",
              name: "test 2",
              builders: [
                {
                  id: "YwRbERhbqOvI-eTrHXLif",
                  title: "Radio",
                  type: "radio",
                  badge: "",
                  body: "Radio with mutlple options",
                  subtitle: [],
                  sort: 17,
                  required: true,
                  options: [
                    {
                      id: "198PvlVXX1r455rTZiFsE",
                      option: "option1",
                      linked: false,
                      linkedForm: "",
                    },
                    {
                      id: "-2smFl-7ScsJXkyml1y7B",
                      option: "option 2",
                      linked: false,
                      linkedForm: "",
                    },
                  ],
                  instruction: "Gone",
                  error: "",
                },
              ],
              error: "",
              linkedToOption: true,
            },
            linkedFormId: "",
          },
        ],
        instruction: "Awesome",
        error: "",
      },
      {
        id: nanoid(),
        title: "Radio",
        type: "radio",
        badge: "",
        body: "Radio with mutlple options",
        subtitle: [],
        sort: 17,
        required: true,
        options: [
          {
            id: "WWLKxKyJVElovqulZejpM",
            option: "option1",
            linked: false,
            linkedForm: "",
          },
          {
            id: "3nn_klCa5VHk79IBLxVq-",
            option: "option 2",
            linked: true,
            linkedForm: {
              id: "zHwcgh9vTr4-oW8ODyNx",
              name: "test 2",
              builders: [
                {
                  id: "YwRbkRhbqOvI-eTrHXLif",
                  title: "Radio",
                  type: "radio",
                  badge: "",
                  body: "Radio with mutlple options",
                  subtitle: [],
                  sort: 17,
                  required: true,
                  options: [
                    {
                      id: "198PvlVXu1r455rTZiFsE",
                      option: "option1",
                      linked: false,
                      linkedForm: "",
                    },
                    {
                      id: "-2smFl-7ScbJXkyml1y7B",
                      option: "option 2",
                      linked: false,
                      linkedForm: "",
                    },
                  ],
                  instruction: "Are",
                  error: "",
                },
              ],
              error: "",
              linkedToOption: true,
            },
            linkedFormId: "",
          },
        ],
        instruction: "Good",
        error: "",
      },
      {
        id: nanoid(),
        title: "Dropdown",
        type: "dropdown",
        badge: "",
        body: "Dropdown with multiple options",
        subtitle: [],
        sort: 16,
        required: true,
        options: [
          {
            id: "WWLKxKyJVElovkulZeLpM",
            option: "option1",
            linked: false,
            linkedForm: "",
          },
          {
            id: "3nn_klCa5Vmk7SIBLxVq-",
            option: "option 2",
            linked: true,
            linkedForm: {
              id: "zHwcgh9vTr4-QW89DyNx",
              name: "test 2",
              builders: [
                {
                  id: "YwRbtRhbqOvI-eTrHXLif",
                  title: "Radio",
                  type: "radio",
                  badge: "",
                  body: "Radio with mutlple options",
                  subtitle: [],
                  sort: 17,
                  required: true,
                  options: [
                    {
                      id: "198PvlVXm1r455rTZiFsE",
                      option: "option1",
                      linked: false,
                      linkedForm: "",
                    },
                    {
                      id: "-2smFl-7ScsJX9yml1y7B",
                      option: "option 2",
                      linked: false,
                      linkedForm: "",
                    },
                  ],
                  instruction: "The Days",
                  error: "",
                },
              ],
              error: "",
              linkedToOption: true,
            },
            linkedFormId: "",
          },
        ],
        instruction: "Nice",
        error: "",
      },
    ],
    error: "",
    linkedToOption: false,
  },
  {
    id: "zHwcgh9vTr4-QW8ODyNxC",
    name: "test 2",
    builders: [
      {
        id: "YwRbERhbqOvI-eTrHXLif",
        title: "Radio",
        type: "radio",
        badge: "",
        body: "Radio with mutlple options",
        subtitle: [],
        sort: 17,
        required: true,
        options: [
          {
            id: "198PvlVXX1r455rTZiFsE",
            option: "option1",
            linked: false,
            linkedForm: "",
          },
          {
            id: "-2smFl-7ScsJXkyml1y7B",
            option: "option 2",
            linked: false,
            linkedForm: "",
          },
        ],
        instruction: "Gone",
        error: "",
      },
    ],
    error: "",
    linkedToOption: true,
  },
  {
    id: "kMAap95UC_x6-vSA9GtSv",
    name: "BANK",
    builders: [
      {
        id: "xct3lEKH6c9swNbN10aDp",
        title: "Bank Info",
        badge: "",
        body: "Select bank and provide bank details",
        subtitle: ["Account Number", "Account Name"],
        sort: 11,
        type: "select",
        required: true,
        instruction: "BANK",
        error: "",
      },
    ],
    error: "",
  },
  {
    id: "j994d5akydXXM4Y-wM4_B",
    name: "Card",
    builders: [
      {
        id: "lCMgOzRS6FjdP-4aPfQk-",
        title: "Card",
        type: "card",
        badge: "",
        body: "Add Debit Card",
        subtitle: [],
        sort: 3,
        required: true,
        instruction: "Card",
        error: "",
      },
    ],
    error: "",
  },
];

export const selectOptions = [
  { title: "Nigeria States", value: "nigeriaStates" },
  { title: "LGA", value: "lgas" },
  { title: "Banks", value: "banks" },
];

export const theme = {
  primaryColor: "#4C5C6D",
  secondaryColor: "#A5ADB6",

  colors: {
    border_color: "#4C5C6D",
    document_background: "rgba(157, 216, 88, 0.12)",
    disabled: "#D3D4D8",
    facebook_blue: "#3B5998",
    color_white: "#FFFFFF",
    color_black: "#000000",
    color_grey: "#A4A59A",
    color_green: "#219653",
    color_red: "#B35151",
    color_yellow: "#CC9E58",
    color_background_grey: "#E5E5E5",
    color_status_success: "#6FCF97",
    color_status_rejected: "#EB5757",
    color_system_fail: "#AE4036",
    color_system_success: "#219653",
    color_system_pending: "#2D9CDB",
    color_primary: "#FBFDFF",
    tertiary_color: "#002C5B",
    text_color_primary: "#4C5C6D",
    text_color_secondary: "#A5ADB6",
    text_color_tertiary: "#002C5B",
  },

  fonts: {
    font_regular: 400,
    font_semibold: 600,
    font_bold: 800,
  },

  font_family: {
    default_font:
      'Proxima Nova", "-apple-system", "BlinkMacSystemFont", "Segoe UI", "Roboto", "Helvetica", "Arial", "sans-serif", "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol',
  },

  break_points: {
    mobile_width: "767px",
    tablet_width: "979px",
    medium_width: "1199px",
  },

  to_rem: (pixelValueWithUnit: any) => {
    const baseValue = 16;
    const pixelValueDigit = pixelValueWithUnit.split("px")[0];
    const remValue = pixelValueDigit / baseValue;
    return remValue + "rem";
  },
};
